import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function JavascriptIcon(props: IconProps) {
    return <Icon {...props} iconKey={"javascript"}/>
}
